export default __webpack_public_path__ + "static/media/376.e0d047e5.png";